<div class="card">
    <h3 class="card-header">{{resources.AddMarkupPercentage}}</h3>
    <div class="card-body">
        <div class="container-fluid">
            <div class="row">
                <div class="form-group col-sm-3 button-allignment ">
                    <label>{{resources.Market}}</label>
                    <div class="input-group">
                        <mat-form-field style="width: 100%;" appearance="outline">
                            <mat-select [formControl]="market">
                                <mat-option value="0" selected disabled="disabled">Select market</mat-option>
                                <mat-option *ngFor="let item of marketList " [value]="item.id">
                                    {{item.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-group col-sm-3 button-allignment ">
                    <label>{{resources.ProductClass}}</label>
                    <div class="input-group">
                        <mat-form-field style="width: 100%;" appearance="outline">
                            <mat-select [formControl]="productClass">
                                <mat-option value="0" selected disabled="disabled">Select Product Class</mat-option>
                                <mat-option *ngFor="let item of productClassList " [value]="item.id">
                                    {{item.variantOption.description}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-group col-sm-3 button-allignment ">
                    <label>{{resources.MarkupCondition}}</label>
                    <div class="input-group">
                        <mat-form-field style="width: 100%;" appearance="outline">
                            <mat-select [formControl]="markupCondition">
                                <mat-option value="0" selected disabled="disabled">Select condition</mat-option>
                                <mat-option *ngFor="let item of markupConditionList " [value]="item.id">
                                    {{item.markupConditionCode}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-group col-sm-3 button-allignment ">
                    <label>{{resources.Percentage}}</label>
                    <div class="input-group">
                        <mat-form-field style="width: 100%;" appearance="outline">
                            <input matInput [formControl]="percentage" type="text"
                                placeholder="{{resources.Percentage}}" maxlength="25" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-group col-sm-3 button-allignment">
                    <label>ValidFrom</label>
                    <div class="input-group " mat-raised-button matTooltip="Allowed to enter past date."
                        matTooltipPosition="below" matTooltipClass="tooltipStyle">
                        <mat-form-field style="width: 100%;" appearance="outline">
                            <input matInput [formControl]="validFrom" type="date" min="{{validDate}}"
                                placeholder="{{resources.validFrom}}">
                        </mat-form-field>
                    </div>

                </div>
            </div>
            <div class="row flex-row-reverse">
                <div class="form-group col-sm-2">
                    <label>&nbsp;</label>
                    <button mat-raised-button type="button" class="btn btn-sm btn-primary form-control"
                        id="saveDeliveryRoute" (click)="onSave()">
                        <i class="fas fa-lg fa-save"></i>&nbsp; {{resources.Save}}
                    </button>
                </div>
                <div class="form-group col-sm-2">
                    <label>&nbsp;</label>
                    <button mat-raised-button type="button" class="btn btn-sm btn-primary form-control"
                        id="saveDeliveryRoute" (click)="onCancel()">
                        <i class="fa fa-lg fa-times" aria-hidden="true"></i>&nbsp; {{resources.Cancel}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<br />